import { useContext } from "react";
import css from "./Footer.module.css";
import logo from "./logo.png";
import { Link, useLocation } from "react-router-dom";
import IAMContext from "../../context/iam";
import NotificationsContext from "../../context/notifications";

const Footer = () => {
  const { logOut, token } = useContext(IAMContext);
  const { addNotification } = useContext(NotificationsContext);
  const location = useLocation();

  if (["/name-list", "/software-engineering/u"].includes(location.pathname))
    return null;

  const logoutHandler = () => {
    addNotification({
      primary: "bye!",
      secondary: "you've been logged out.",
      type: "success",
      showTime: 5,
    });
    logOut();
  };

  return (
    <div className={css.main}>
      <Link to="/">
        <img
          className={css.logo}
          src={logo}
          alt="the squidslippers logo: a white squid-shaped creature with two 'S'-shaped tentacles."
        />
      </Link>
      <nav className={css.container}>
        {token && (
          <div className={css.row}>
            <strong className={css.title}>ADMIN</strong>
            <div className={css.links}>
              <Link className={css.link} to="/admin/dashboard">
                dashboard
              </Link>
              <Link className={css.link} to="/admin/live">
                live
              </Link>
              <button
                className={css.link}
                style={{ width: "fit-content" }}
                onClick={logoutHandler}
              >
                log out
              </button>
            </div>
          </div>
        )}
        <div className={css.row}>
          <strong className={css.title}>HOBBIES</strong>
          <div className={css.links}>
            <Link className={css.link} to="/animal-crossing">
              Animal Crossing
            </Link>
            <Link className={css.link} to="/art">
              Art
            </Link>
            <Link className={css.link} to="/photography">
              Photography
            </Link>
            <Link className={css.link} to="/software-engineering">
              Software Engineering
            </Link>
          </div>
        </div>
        <div className={css.row}>
          <strong className={css.title}>RESOURCES</strong>
          <div className={css.links}>
            <a
              className={css.link}
              href="https://bendybudget.com/"
              target="_blank"
              rel="noopener"
            >
              Bendy Budget
            </a>
            <Link className={css.link} to="/cookbook">
              Cookbook
            </Link>
            <a
              className={css.link}
              href="https://crystal-clear-consulting.com/"
              target="_blank"
              rel="noopener"
            >
              Crystal Clear Consulting
            </a>
            <Link className={css.link} to="/software-engineering/queues">
              Queue Tutorial
            </Link>
          </div>
        </div>

        <div className={css.row}>
          <strong className={css.title}>CONTACT</strong>
          <div className={css.links}>
            <a className={css.link} href="mailto:jacob.w.moreno@gmail.com">
              jacob.w.moreno@gmail.com
            </a>
            <a className={css.link} href="sms:+18018678774">
              801-867-8774
            </a>
          </div>
        </div>
        <div className={css.row}>
          <strong className={css.title}>LEGAL</strong>
          <div className={css.links}>
            <span className={css.link}>©SquidSlippers, LLC 2026</span>
            <Link className={css.link} to="/privacy-policy">
              Privacy Policy
            </Link>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Footer;
